import { Component } from '@angular/core';
import { OrderBookComponent } from './shared/components/order-book/order-book.component';
import { RealEstateComponent } from './shared/components/real-estate/real-estate.component';
import { PortfolioComponent } from './shared/components/portfolio-details/portfolio-details.components';
import { AllocationDashboardComponent } from './shared/components/allocation-dashboard/allocation-dashboard.component';
import { FundOverviewComponent } from './shared/components/fund-overview/fund-overview.component';
import { SideNavBarComponent} from './shared/shared/side-nav-bar/side-nav-bar.component';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,SideNavBarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {}

